module.exports = __webpack_public_path__ + "media/images/cc-a7b4dee0caa2b5528b03ab962a0f923b.png";